
import Vue from 'vue'
export default Vue.extend({
    name: 'TextCard',
    props: {
        body: String,
    }
})
